import React from 'react'

const BackToTop = ({
  newsFeed = false
}) => {

  const onClick = (e) => {
    e.preventDefault()
    try{
      window.scrollTo(0,0)
    }catch(e) {
      console.log(e)
    }
  }

  return (
    newsFeed ? <span className="backtotop">Back to Top</span> : <a onClick={onClick} className="back-to-top button-alt icon-font-before icon-arrow-up-solid-before"></a>
  )
}

export default BackToTop



// WEBPACK FOOTER //
// ../app/components/common/BackToTop.jsx